import React, { useEffect } from 'react'
import event8 from './eventImg/event-14-june.webp'


const Event13 = () => {
    useEffect(() => {
        document.title = "DELHI TO HOST A FULL DAY WORKSHOP BUILT ENVIRONMENT NBC - THE CHANGE AWAITED";
      }, []);
  return (
    <>
    <div className='eventheading'>

<h1  className='text-center'>14 June 2025</h1> 
<h3 className='text-center'>DELHI TO HOST A FULL DAY WORKSHOP BUILT ENVIRONMENT NBC - THE CHANGE AWAITED</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={event8} alt='DELHI TO HOST A FULL DAY WORKSHOP BUILT ENVIRONMENT NBC - THE CHANGE AWAITED'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/GYP6EVeraZE=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event13

